export default __webpack_public_path__ + "static/media/remove-knife-block.71402d2d.svg";